export default [
  {
    path: "/ainB5ftYO3bdMEPOgXKE",
    children: [
      {
        path: "/3hjOkY",
        name: "role-mng",
        meta: {
          title: "All roles",
          authRequired: true,
          acc: ["y37228"],
        },
        component: () => import("../views/settings/roles/roles.vue"),
      },
      {
        path: "/jqipVJIqV",
        name: "newRole",
        meta: {
          title: "New role",
          authRequired: true,
          acc: ["y99468"],
        },
        component: () => import("../views/settings/roles/newRole.vue"),
      },
      {
        path: "/B5LzxoiGFf",
        name: "role-1",
        meta: {
          title: "Role",
          authRequired: true,
          acc: ["y55206"],
        },
        component: () => import("../views/settings/roles/role.vue"),
      },
    ],
  },
];
